import { Link } from "react-router-dom";
import { CalendarDays, ClipboardList, MapPin } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { STATUS, fileUrl, money } from "@/lib/api";
import { thumbFor } from "@/lib/images";

export default function ProjectCard({ p, showBudget, i = 0 }) {
  return (
    <Link to={`/projects/${p.id}`} data-testid={`project-card-${p.id}`} style={{ animationDelay: `${i * 60}ms` }}
      className="rise lift group block overflow-hidden rounded-xl border bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
      <div className="aspect-[16/10] overflow-hidden bg-muted">
        <img src={fileUrl(p.hero_image) || thumbFor(p.id)} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      </div>
      <div className="space-y-2 p-5">
        <div className="flex items-center justify-between gap-2">
          <h3 className="truncate section-title">{p.name}</h3>
          <Badge variant="secondary" className="shrink-0">{STATUS[p.status] || p.status}</Badge>
        </div>
        <p className="text-sm text-muted-foreground">{p.client_name || "No client yet"}</p>
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground">
          {p.address && <span className="flex items-center gap-1"><MapPin className="h-3 w-3" />{p.address}</span>}
          {p.start_date && <span className="flex items-center gap-1"><CalendarDays className="h-3 w-3" />{p.start_date}</span>}
          {showBudget && p.budget ? <span className="font-mono">{money(p.budget)}</span> : null}
        </div>
        {p.status === "pre_start" && p.planning && (
          <div className="pt-1" data-testid={`project-planning-${p.id}`}>
            <div className="flex items-center justify-between text-xs"><span className="flex items-center gap-1 text-muted-foreground"><ClipboardList className="h-3 w-3" />Pre-start planning</span><span className="stat" data-testid={`project-planning-count-${p.id}`}>{p.planning.settled} of {p.planning.total} settled</span></div>
            <div className="mt-1 h-1 overflow-hidden rounded-full bg-secondary"><div className="h-full rounded-full bg-primary" style={{ width: `${p.planning.total ? Math.round((p.planning.settled / p.planning.total) * 100) : 0}%` }} /></div>
          </div>
        )}
      </div>
    </Link>
  );
}
